exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ARNGDsKAGimPc4{padding:0;text-align:center;background-color:#faf3c0;border-bottom:1px solid #e6c60d}._37PirlDOIrPmtl{line-height:32px;margin:0;font-weight:700}._37PirlDOIrPmtl a{color:#5e6c84;margin-left:8px}", ""]);

// exports
exports.locals = {
	"banner": "ARNGDsKAGimPc4",
	"text": "_37PirlDOIrPmtl"
};